import {Injectable} from '@angular/core';
import {DasboardConfiguration, Dashboard} from '../models/dashboard';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthorizationService} from './authorization.service';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {environment} from '../environments/enviroment';

@Injectable({
  providedIn: 'root'
})
export class MsReportService {

  private baseDomain: string = `${environment.mindxbkUrl}DashBoard/`;
  private embedConfSubject: BehaviorSubject<DasboardConfiguration | null> = new BehaviorSubject<DasboardConfiguration | null>(null);

  constructor(
    private http: HttpClient,
    private authService: AuthorizationService
  ) {

  }

  get baseUrl(): string {
    return this.baseDomain;
  }

  public GetDashboards(): Observable<Dashboard[]> {
    const url = `${this.baseDomain}GetDashboards`;

    // Leer el token directamente desde localStorage
    const token = localStorage.getItem('auth_req');
    if (!token) {
      console.error('❌ No se encontró token en localStorage (auth_req)');
      return throwError(() => new Error('No auth token available'));
    }

    const headers = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    });

    return this.http.get<Dashboard[]>(url, { headers });
  }

  public GetEmbedConfig(): Observable<DasboardConfiguration> {
    const url = `${this.baseDomain}GetData`;

    const token = localStorage.getItem('auth_req');
    if (!token) {
      console.error('❌ No se encontró token en localStorage (auth_req)');
      return throwError(() => new Error('No auth token available'));
    }

    const headers = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    return this.http.get<DasboardConfiguration>(url, { headers });
  }

  get embedConf$(): Observable<DasboardConfiguration | null> {
    return this.embedConfSubject.asObservable();
  }
  setEmbedConf(embedConf: DasboardConfiguration) {
    this.embedConfSubject.next(embedConf);
  }
  getEmbedConf(): Observable<DasboardConfiguration | null> {
    return this.embedConf$;
  }




}
